var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInfoDraw = function SvgInfoDraw(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "851px",
    height: "900px",
    viewBox: "0 0 851 900",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1080-copy-3",
    transform: "translate(-115.000000, -90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_completed_ngx6",
    transform: "translate(115.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D3E7FA",
    fillRule: "nonzero",
    cx: 477.83511,
    cy: 500.15034,
    r: 373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.02043,434.19111 C262.681176,429.546836 264.055999,424.277313 264.00334,418.92511 C264.00334,405.12859 255.45976,393.9443 244.92078,393.9443 C234.3818,393.9443 225.83822,405.12859 225.83822,418.92511 C225.785581,424.27731 227.160402,429.546829 229.82113,434.19111 C224.510574,443.675725 224.510574,455.238625 229.82113,464.72324 C224.510593,474.207842 224.510593,485.770718 229.82113,495.25532 C224.510593,504.739922 224.510593,516.302798 229.82113,525.7874 C227.160401,530.43168 225.785579,535.701199 225.83822,541.0534 C225.83822,554.84992 234.38175,566.03421 244.92078,566.03421 C255.45981,566.03421 264.00334,554.84992 264.00334,541.0534 C264.056,535.701197 262.681178,530.431673 260.02043,525.7874 C265.330967,516.302798 265.330967,504.739922 260.02043,495.25532 C265.330967,485.770718 265.330967,474.207842 260.02043,464.72324 C265.330986,455.238625 265.330986,443.675725 260.02043,434.19111 L260.02043,434.19111 Z",
    id: "Path",
    fill: "#455A64",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 244.92076,
    cy: 388.393,
    rx: 19.08256,
    ry: 24.9808
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 244.92076,
    cy: 357.86091,
    rx: 19.08256,
    ry: 24.9808
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.35627,148.92006 C318.963271,145.600951 321.337787,142.105651 323.46285,138.45914 L273.32185,130.22423 L327.5507,130.62753 C338.064507,107.75209 338.695845,81.5569086 329.29626,58.20153 L256.54174,95.94287 L323.63832,46.62201 C306.504672,17.0142562 274.273939,-0.549639195 240.10591,1.10165175 C205.937881,2.75294269 175.551076,23.3430522 161.352408,54.4650511 C147.153741,85.58705 151.519566,122.032216 172.66732,148.92001 C168.603609,154.08578 165.108583,159.67455 162.24281,165.58947 L227.32941,199.40394 L157.92895,176.11194 C148.029093,205.377009 153.572508,237.662017 172.66732,261.94863 C143.193052,299.420959 147.46935,353.253583 182.490014,385.602633 C217.510678,417.951683 271.512882,417.951683 306.533546,385.602633 C341.55421,353.253583 345.830508,299.420959 316.35624,261.94863 C342.437961,228.786255 342.437961,182.082385 316.35624,148.92001 L316.35627,148.92006 Z",
    id: "Path",
    fill: "#2892FE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.104637,205.43437 C153.074498,225.93809 159.96722,245.851779 172.66735,261.94868 C143.193082,299.421009 147.46938,353.253633 182.490044,385.602683 C217.510708,417.951733 271.512912,417.951733 306.533576,385.602683 C341.55424,353.253633 345.830538,299.421009 316.35627,261.94868 C328.60738,246.39584 153.104637,195.17525 153.104637,205.43437 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.58388,746.54395 C722.93026,830.83095 540.41725,909.00505 346.33105,854.53827 C152.24485,800.07149 20.08196,633.58932 43.73556,549.3023 C67.38916,465.01528 237.90219,494.84121 431.98839,549.30799 C626.07459,603.77477 770.23756,662.25694 746.58388,746.54395 Z",
    id: "Path",
    fill: "#78909C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.58388,746.54395 C722.93026,830.83095 540.41725,909.00505 346.33105,854.53827 C152.24485,800.07149 20.08196,633.58932 43.73556,549.3023 C67.38916,465.01528 237.90219,494.84121 431.98839,549.30799 C626.07459,603.77477 770.23756,662.25694 746.58388,746.54395 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.203306362
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#78909C",
    fillRule: "nonzero",
    transform: "translate(395.159706, 647.923074) rotate(-74.324190) translate(-395.159706, -647.923074) ",
    cx: 395.159706,
    cy: 647.923074,
    rx: 158.51081,
    ry: 365
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.2,
    cx: 455.83511,
    cy: 663.15034,
    rx: 107,
    ry: 31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.59074,484.75526 L452.25774,620.08845 L395.37674,563.20682 C387.78336,555.61337 375.472002,555.613312 367.87855,563.20669 L365.83513,560.15034 C358.24165,567.74375 360.28502,583.11154 367.87848,590.70498 L441.68101,664.50733 C447.472754,670.299054 456.862252,670.301498 462.65701,664.51279 L615.07493,512.25379 C622.67328,504.66336 625.4296,490.74465 617.83512,483.15036 L617.83512,483.15036 C610.24356,475.55898 595.18219,477.1638 587.59074,484.75526 Z",
    id: "Path",
    fill: "#2892FE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.59074,484.75526 L452.25774,620.08845 L395.37674,563.20682 C387.78336,555.61337 375.472002,555.613312 367.87855,563.20669 L365.83513,560.15034 C358.24165,567.74375 360.28502,583.11154 367.87848,590.70498 L441.68101,664.50733 C447.472754,670.299054 456.862252,670.301498 462.65701,664.51279 L615.07493,512.25379 C622.67328,504.66336 625.4296,490.74465 617.83512,483.15036 L617.83512,483.15036 C610.24356,475.55898 595.18219,477.1638 587.59074,484.75526 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.59074,478.75526 L452.25774,614.08845 L395.37674,557.20682 C387.78336,549.61337 375.472002,549.613312 367.87855,557.20669 L367.87855,557.20669 C364.232038,560.853177 362.183446,565.798891 362.183446,570.95582 C362.183446,576.112749 364.232038,581.058463 367.87855,584.70495 L441.68108,658.5073 C447.472824,664.299024 456.862322,664.301468 462.65708,658.51276 L615.075,506.25376 C618.72375,502.608813 620.775811,497.663298 620.775811,492.505875 C620.775811,487.348452 618.728894,482.401894 615.082,478.75509 L615.082,478.75509 C607.490439,471.163665 595.182207,471.163741 587.59074,478.75526 Z",
    id: "Path",
    fill: "#2892FE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.392,421.79317 C52.392,463.96343 78.84741,498.08707 111.54121,498.08707",
    id: "Path",
    fill: "#455A64",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.54121,498.08711 C111.54121,455.44303 141.06391,420.93598 177.5483,420.93598",
    id: "Path",
    fill: "#2892FE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.82288,425.61601 C73.82288,465.67328 90.69299,498.08711 111.54121,498.08711",
    id: "Path",
    fill: "#2892FE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.54121,498.08711 C111.54121,443.59745 145.66485,399.50511 187.83512,399.50511",
    id: "Path",
    fill: "#455A64",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.09774,495.519517 C96.09774,495.519517 108.191279,495.144602 111.835965,492.532317 C115.48065,489.920032 130.438881,486.800794 131.343035,490.990344 C132.247189,495.179894 149.517389,511.827255 135.863834,511.938107 C122.210278,512.048959 104.139007,509.797455 100.5014,507.567123 C96.8637926,505.33679 96.09774,495.519517 96.09774,495.519517 Z",
    id: "Path",
    fill: "#A8A8A8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.110242,510.518713 C122.455745,510.626637 104.383193,508.435173 100.745331,506.264302 C97.974848,504.611074 96.870839,498.678902 96.5014471,495.94204 C96.2456265,495.952803 96.09774,495.95745 96.09774,495.95745 C96.09774,495.95745 96.8637597,505.512929 100.501694,507.683785 C104.139628,509.854642 122.212107,512.046135 135.866619,511.93821 C139.808126,511.907066 141.169599,510.533303 141.094841,508.498648 C140.547227,509.727933 139.043966,510.495549 136.110242,510.518713 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.175789,114.610526 C177.995463,113.443282 178.447448,112.057635 178.473684,110.631579 C178.473684,101.991579 160.871579,95 139.157895,95 C117.444211,95 99.8421053,101.991579 99.8421053,110.631579 C99.8814555,112.247105 100.450659,113.804926 101.462105,115.065263 C77.2852632,117.765263 61,122.824211 61,128.631579 C61,137.262105 97.0473684,144.263158 141.526316,144.263158 C186.005263,144.263158 222.052632,137.262105 222.052632,128.631579 C222.005263,122.521053 203.702105,117.168421 177.175789,114.610526 Z",
    id: "Path",
    fill: "#2892FE",
    fillRule: "nonzero",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.251579,57.6105263 C714.071252,56.4432822 714.523237,55.0576346 714.549474,53.6315789 C714.549474,44.9915789 696.947368,38 675.233684,38 C653.52,38 635.917895,44.9915789 635.917895,53.6315789 C635.93559,55.2382869 636.477848,56.7951995 637.462105,58.0652632 C613.285263,60.7652632 597,65.8242105 597,71.6315789 C597,80.2621053 633,87.2631579 677.526316,87.2631579 C722.052632,87.2631579 758.052665,80.2621053 758.052665,71.6315789 C758.081053,65.5210526 739.777895,60.1684211 713.251579,57.6105263 Z",
    id: "Path",
    fill: "#2892FE",
    fillRule: "nonzero",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,114.389547 C408.809344,112.752963 412.607385,114.31681 414.536549,116.959591 C416.465712,119.602371 416.948003,123.021013 417.49058,126.197198 C418.563677,133.373922 419.3474,141.605334 414.536549,147 C422.39789,123.033136 445.005275,104.679149 470,102",
    id: "Path",
    stroke: "#2892FE",
    strokeWidth: 3,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518,196.861332 C520.022867,195.695015 522.746995,196.861332 524.13603,198.684541 C525.37302,200.66938 526.104402,202.924163 526.266784,205.253456 C527.035473,210.361123 527.615362,216.206116 524.149516,220 C530.183889,202.635244 545.653503,190.213121 564,188",
    id: "Path",
    stroke: "#2892FE",
    strokeWidth: 3,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,215.262105 C85.4210526,214.437895 87.3347368,215.262105 88.3105263,216.550526 C89.1795042,217.953167 89.6932959,219.546572 89.8073684,221.192632 C90.3473684,224.802105 90.7547368,228.932632 88.32,231.613684 C92.5591125,219.3424 103.426427,210.563963 116.314737,209",
    id: "Path",
    stroke: "#2892FE",
    strokeWidth: 3,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588,83.2621053 C589.421053,82.4378947 591.334737,83.2621053 592.310526,84.5505263 C593.179504,85.9531673 593.693296,87.5465721 593.807368,89.1926316 C594.347368,92.8021053 594.754737,96.9326316 592.32,99.6136842 C596.559112,87.3423997 607.426427,78.5639628 620.314737,77",
    id: "Path",
    stroke: "#2892FE",
    strokeWidth: 3,
    opacity: 0.6
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoDraw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-draw.f6a3fc6a.svg";
export { ForwardRef as ReactComponent };